import React from 'react';
import { Dialog, Tooltip, Flex, IconButton } from '@radix-ui/themes';
import { toast } from 'sonner';
import { observer } from 'mobx-react-lite';
import { CheckIcon, DeleteIcon, EditIcon, NotInterestedIcon } from 'shared/icons';

import { useNavigate } from 'react-router-dom';
import { ManageBlog } from 'admin/blogs-managment/types';
import { useBlogsManager } from '../blogs-manager.provider';
import { BlogsConfirmDialog } from '../blogs-confirm-dialog';

import './blogs-actions-menu.scss';

type MangerBlogMenuAction =  'DEACTIVATE' | 'ACTIVATE' | 'EMPTY' | 'DELETE';

const BlogsActionsMenuView = ({ blog }: { blog: ManageBlog }) => {
   const blogsManager = useBlogsManager();
   const navigate = useNavigate();
   const [open, setOpen] = React.useState<boolean>(false);
   const [action, setAction] = React.useState<MangerBlogMenuAction>('EMPTY');
   return (
      <Flex className="blogs-actions-menu" gap="1" align="center" justify="center">
         {
            {
               0: (
                  <Tooltip content="Activate" side="left">
                     <IconButton
                        color="red"
                        className="action-trigger"
                        onClick={() => {
                           setOpen(true);
                           setAction('ACTIVATE');
                        }}
                     >
                        <NotInterestedIcon width={20} height={20} />
                     </IconButton>
                  </Tooltip>
               ),

               1: (
                  <Tooltip content="Deactivate" side="left">
                     <IconButton
                        color="green"
                        className="action-trigger"
                        onClick={() => {
                           setOpen(true);
                           setAction('DEACTIVATE');
                        }}
                     >
                        <CheckIcon width={20} height={20} />
                     </IconButton>
                  </Tooltip>
               ),
            }[blog.status]
         }

         <Tooltip content="Edit order" side="top">
            <IconButton
               color="blue"
               className="action-trigger"
               highContrast
               onClick={() => {
                  navigate(`/admin/blogs/editblogs/${blog.slug}`);
               }}
            >
               <EditIcon width={20} height={20} />
            </IconButton>
         </Tooltip>

         <Tooltip content="Delete" side="top">
            <IconButton
               color="red"
               className="action-trigger"
               onClick={() => {
                  setOpen(true);
                  setAction('DELETE');
               }}
            >
               <DeleteIcon width={20} height={20} />
            </IconButton>
         </Tooltip>

         <Dialog.Root
            open={open}
            onOpenChange={(o) => {
               if (!o) {
                  setAction('EMPTY');
               }
               setOpen(o);
            }}
         >
            <Dialog.Content
               aria-describedby={undefined}
               onOpenAutoFocus={(e) => e.preventDefault()}
            >
               {
                  {
                     DEACTIVATE: (
                        <BlogsConfirmDialog
                           title="Deactivate Blog?"
                           message="Do you want to Deactivate this Blog?"
                           loading={blogsManager.deactivateBlogState.status === 'pending'}
                           onConfirm={() => {
                              blogsManager.deactivateBlog({
                                 dto: { slug: blog.slug },
                                 onSuccess: (resp) => {
                                    setOpen(false);
                                    toast.success(resp.response);
                                 },
                                 onError: (err) => {
                                    toast.error(err);
                                 },
                              });
                           }}
                        />
                     ),
                     ACTIVATE: (
                        <BlogsConfirmDialog
                           title="Activate Blog?"
                           message="Do you want to Activate this Blog?"
                           loading={blogsManager.activateBlogState.status === 'pending'}
                           onConfirm={() => {
                              blogsManager.activatePlan({
                                 dto: { slug: blog.slug },
                                 onSuccess: (resp) => {
                                    setOpen(false);
                                    toast.success(resp.response);
                                 },
                                 onError: (err) => {
                                    toast.error(err);
                                 },
                              });
                           }}
                        />
                     ),
                     DELETE: (
                        <BlogsConfirmDialog
                           title="Delete Blog"
                           message="Do you want to Delete this Blog?"
                           loading={blogsManager.deleteBlogState.status === 'pending'}
                           onConfirm={() => {
                              blogsManager.deleteBlog({
                                 dto: { slug: blog.slug },
                                 onSuccess: (resp) => {
                                    setOpen(false);
                                    toast.success(resp['message']);
                                 },
                                 onError: (err) => {
                                    toast.error(err);
                                 },
                              });
                           }}
                        />
                     ),
                     EMPTY: <></>,
                  }[action]
               }
            </Dialog.Content>
         </Dialog.Root>
      </Flex>
   );
};

export const BlogsActionsMenu = observer(BlogsActionsMenuView);
